import React, { useState, useEffect, useCallback } from 'react'
import Header from '../Component/Header';
import Footer from '../Component/footer';
import PageHead from '../Component/pageHead'
import { Form } from 'react-bootstrap'
import { PostAction } from '../Component/PostAction';
import { useFormik } from 'formik';
import { GetAction } from '../Component/GetAction'
import { Link } from 'react-router-dom'

const sessionVal = (key, fallback = '') =>
  sessionStorage.getItem(key) ? sessionStorage.getItem(key) : fallback

const buildInitialFormData = () => ({
  id: sessionVal('id'),
  firstName: sessionVal('first_name'),
  lastName: sessionVal('last_name'),
  email: sessionVal('email_address'),
  mobile: sessionVal('mobile'),
  adharCard: sessionVal('adhar_card'),
  panNumber: sessionVal('pan_number'),
  address1: sessionVal('address1'),
  address2: sessionVal('address2'),
  city: sessionVal('city'),
  country_id: sessionVal('country_id', '99'),
  country_name: sessionVal('country_name', 'India'),
  state: sessionVal('state'),
  state_name: sessionVal('state'),
  zip_no: sessionVal('zip_no'),
  product_id: '',
  product_name: '',
  same_address: '',
  save_info: '',
  donation_amount: '',
})

function isLoggedIn() {
  return Boolean(sessionStorage.getItem('id'))
}

function formatAmount(value) {
  if (value == null || value === '') return '—'
  const n = Number(value)
  if (Number.isNaN(n)) return String(value)
  return `₹ ${n.toLocaleString('en-IN')}`
}

/** Browser POST redirect to BasisPay (same pattern as legacy gateway form). */
function submitBasisPayForm(gateway) {
  if (!gateway?.url || !gateway?.fields) return false
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = gateway.url
  form.style.display = 'none'
  Object.keys(gateway.fields).forEach((key) => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = key
    input.value = gateway.fields[key] == null ? '' : String(gateway.fields[key])
    form.appendChild(input)
  })
  document.body.appendChild(form)
  form.submit()
  return true
}

function Donation() {
  const loggedIn = isLoggedIn()
  const [getDetails, setDetails] = useState([])
  const [countryId, setCountryId] = useState('99')
  const [formData] = useState(buildInitialFormData)
  const [counrtyData, setCountryData] = useState([])
  const [listData, setListData] = useState([])
  const [pendingDonations, setPendingDonations] = useState([])
  const [pendingLoading, setPendingLoading] = useState(false)
  const [payingId, setPayingId] = useState(null)
  const [payMessage, setPayMessage] = useState('')
  const postUrl = '/donation/checkout'

  const requestAPI = async () => {
    const url = `/donation_type/donationTypes`
    const res = await GetAction('get', { page_id: 1 }, url)
    setDetails(res?.response || [])
  }

  useEffect(() => {
    requestAPI()
  }, [])

  const loadPendingDonations = useCallback(async () => {
    const userId = sessionStorage.getItem('id')
    if (!userId) {
      setPendingDonations([])
      return
    }
    setPendingLoading(true)
    const res = await GetAction(
      'get',
      { user_id: userId, status: 'unpaid' },
      'donation/DonationHistory'
    )
    const rows = Array.isArray(res?.response) ? res.response : []
    setPendingDonations(rows)
    setPendingLoading(false)
  }, [])

  useEffect(() => {
    if (loggedIn) {
      loadPendingDonations()
    }
  }, [loggedIn, loadPendingDonations])

  // After BasisPay return (?payment=success|failed), refresh unpaid list
  useEffect(() => {
    if (!loggedIn) return
    const params = new URLSearchParams(window.location.search || '')
    const payment = params.get('payment')
    if (!payment) return
    setPayMessage(
      payment === 'success'
        ? 'Payment successful. Pending list updated.'
        : 'Payment was not completed. You can try again.'
    )
    loadPendingDonations()
    if (window.history?.replaceState) {
      const clean = window.location.pathname
      window.history.replaceState({}, '', clean)
    }
  }, [loggedIn, loadPendingDonations])

  const payPendingDonation = async (row) => {
    const userId = sessionStorage.getItem('id')
    if (!userId) {
      alert('Please login to pay.')
      return
    }
    const detailId = row.payment_detail_id
    const paymentId = row.payment_id
    if (!detailId && !paymentId) {
      alert('Missing donation reference.')
      return
    }
    setPayingId(detailId || paymentId)
    setPayMessage('')
    const res = await PostAction(
      'post',
      {
        user_id: Number(userId),
        payment_detail_id: detailId ? Number(detailId) : undefined,
        payment_id: paymentId ? Number(paymentId) : undefined,
      },
      'donation/initiatePayment'
    )
    if (res?.status === 'success' && res.response?.url && res.response?.fields) {
      submitBasisPayForm(res.response)
      return
    }
    setPayingId(null)
    alert(res?.message || 'Unable to start payment.')
  }

  const handleCountry = (event) => {
    setCountryId(event.target.value)
    values.country_name = event.target[event.target.selectedIndex].getAttribute('data-name')
    callStateAPI()
  }

  useEffect(() => {
    if (loggedIn) return
    const callCountryAPI = async () => {
      const countryUrl = `/Master/countryList`
      const res = await GetAction('get', {}, countryUrl)
      setCountryData((await res.response) || [])
    }
    callCountryAPI()
  }, [loggedIn])

  const callStateAPI = async () => {
    const stateUrl = `/Master/stateList`
    const res = await GetAction('get', { country_id: countryId }, stateUrl)
    setListData((await res.response) || [])
  }

  useEffect(() => {
    if (loggedIn) return
    callStateAPI()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryId, loggedIn])

  const changeState = (event) => {
    values.state = event.target.value
    values.state_name = event.target[event.target.selectedIndex].getAttribute('data-name')
    callStateAPI()
  }

  const { values, errors, handleChange, handleSubmit, setFieldValue } = useFormik({
    initialValues: formData,
    onSubmit: (submitValues) => {
      const payload = loggedIn
        ? {
            ...submitValues,
            id: sessionVal('id'),
            firstName: sessionVal('first_name'),
            lastName: sessionVal('last_name'),
            email: sessionVal('email_address'),
            mobile: sessionVal('mobile'),
            adharCard: sessionVal('adhar_card'),
            panNumber: sessionVal('pan_number'),
            address1: sessionVal('address1'),
            address2: sessionVal('address2'),
            city: sessionVal('city'),
            country_id: sessionVal('country_id', '99'),
            country_name: sessionVal('country_name', 'India'),
            state: sessionVal('state'),
            state_name: sessionVal('state'),
            zip_no: sessionVal('zip_no'),
          }
        : submitValues

      const callPOSTAPI = async () => {
        const res = await PostAction('post', payload, postUrl)
        alert(res.message)
        if (loggedIn) {
          loadPendingDonations()
        }
      }
      callPOSTAPI()
    },
  })

  return (
    <>
      <Header />
      <PageHead title="ऑनलाइन दान" />
      <section className="donation-page">
        <div className="container">
          <div className="donation-card">
            <div className="donation-card-header">
              <h2 className="donation-card-title">ऑनलाइन दान</h2>
              <p className="donation-card-subtitle">
                आप हमें आपकी दान राशी यहाँ से भी सीधे भेज सकते है। ऑनलाइन दान से संबधी किसी भी प्रकार की
                जानकारी के लिए संपर्क करे ०८९८३ ७८३ ७८३।
              </p>
            </div>

            <Form onSubmit={handleSubmit} className="donation-form">
              <div className="row">
                <div className="col-12 col-md-6 mb-3">
                  <label className="form-label" htmlFor="product_id">
                    दान प्रकार / Donation type
                  </label>
                  <select
                    className="form-control"
                    id="product_id"
                    name="product_id"
                    value={values.product_id}
                    onChange={(e) => {
                      const amount = e.target[e.target.selectedIndex].getAttribute('data-amount')
                      const name = e.target[e.target.selectedIndex].getAttribute('data-name')
                      setFieldValue('donation_amount', amount || '')
                      setFieldValue('product_name', name || '')
                      handleChange(e)
                    }}
                  >
                    <option value="">Select donation type</option>
                    {getDetails.map((item) => (
                      <option
                        key={item.donation_type_id}
                        value={item.donation_type_id}
                        data-amount={item.amount}
                        data-name={item.name}
                      >
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
                {loggedIn ? (
                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label" htmlFor="donation_amount">
                      दान राशी / Amount
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={values.donation_amount}
                      onChange={handleChange}
                      id="donation_amount"
                      name="donation_amount"
                    />
                  </div>
                ) : null}
              </div>

              {!loggedIn ? (
                <>
                  <h3 className="donation-section-title">Billing address</h3>
                  <div className="row">
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label" htmlFor="firstName">
                        First name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="firstName"
                        id="firstName"
                        value={values.firstName}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label" htmlFor="lastName">
                        Last name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="lastName"
                        id="lastName"
                        value={values.lastName}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label" htmlFor="email">
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        id="email"
                        value={values.email}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label" htmlFor="mobile">
                        Mobile
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="mobile"
                        id="mobile"
                        value={values.mobile}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label" htmlFor="adharCard">
                        Aadhaar Card Number <span className="text-muted">(Optional)</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="adharCard"
                        id="adharCard"
                        value={values.adharCard}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label" htmlFor="panNumber">
                        PAN Number <span className="text-muted">(Optional)</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="panNumber"
                        id="panNumber"
                        value={values.panNumber}
                        onChange={handleChange}
                      />
                      {errors.panNumber ? (
                        <span id="lblPANCard" className="text-danger">
                          Invalid PAN Number
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label" htmlFor="address1">
                      Address
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="address1"
                      id="address1"
                      value={values.address1}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label" htmlFor="address2">
                        Address 2 <span className="text-muted">(Optional)</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="address2"
                        name="address2"
                        value={values.address2}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label" htmlFor="city">
                        City
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="city"
                        id="city"
                        value={values.city}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-5 mb-3">
                      <label className="form-label" htmlFor="country">
                        Country
                      </label>
                      <select
                        className="form-control"
                        id="country"
                        name="country_id"
                        onChange={(e) => {
                          handleCountry(e)
                          handleChange(e)
                        }}
                        value={values.country_id}
                      >
                        {counrtyData.map((country, index) => (
                          <option key={index} value={country.country_id} data-name={country.name}>
                            {country.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 col-md-4 mb-3">
                      <label className="form-label" htmlFor="state">
                        State
                      </label>
                      <select
                        className="form-control"
                        id="state"
                        name="state"
                        onChange={(e) => {
                          changeState(e)
                          handleChange(e)
                        }}
                        value={values.state}
                      >
                        {listData.map((state, index) => (
                          <option key={index} value={state.zone_id} data-name={state.name}>
                            {state.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 col-md-3 mb-3">
                      <label className="form-label" htmlFor="zip">
                        Zip
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="zip_no"
                        id="zip"
                        value={values.zip_no}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="donation-checkboxes mb-3">
                    <label className="donation-check" htmlFor="same-address">
                      <input
                        type="checkbox"
                        id="same-address"
                        name="same_address"
                        value="Y"
                        onChange={handleChange}
                      />
                      <span>Shipping address is the same as my billing address</span>
                    </label>
                    <label className="donation-check" htmlFor="save-info">
                      <input
                        type="checkbox"
                        id="save-info"
                        name="save_info"
                        value="Y"
                        onChange={handleChange}
                      />
                      <span>Save this information for next time</span>
                    </label>
                  </div>

                  <h3 className="donation-section-title">Payment</h3>
                  <div className="row">
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label" htmlFor="donation_amount">
                        Donation Amount
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        value={values.donation_amount}
                        onChange={handleChange}
                        id="donation_amount"
                        name="donation_amount"
                      />
                    </div>
                  </div>
                </>
              ) : null}

              <div className="donation-actions">
                <button className="btn donation-submit-btn" type="submit">
                  Continue to checkout
                </button>
              </div>
            </Form>
          </div>

          {loggedIn ? (
            <div className="donation-card donation-pending-card">
              <div className="donation-card-header">
                <h2 className="donation-card-title">Pending donations</h2>
                <p className="donation-card-subtitle">
                  Complete payment for unpaid donations below. Paid items leave this list
                  automatically.
                </p>
              </div>

              {payMessage ? <p className="donation-pay-message">{payMessage}</p> : null}

              {pendingLoading ? (
                <p className="donation-empty">Loading pending donations…</p>
              ) : pendingDonations.length === 0 ? (
                <p className="donation-empty">You have no pending / unpaid donations.</p>
              ) : (
                <div className="table-responsive donation-pending-table-wrap">
                  <table className="table donation-pending-table">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Type</th>
                        <th>Amount</th>
                        <th>Order / Receipt</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pendingDonations.map((row) => {
                        const rowKey = row.payment_detail_id || row.payment_id || row.order_id
                        const busy =
                          payingId != null &&
                          String(payingId) === String(row.payment_detail_id || row.payment_id)
                        return (
                          <tr key={rowKey}>
                            <td>{row.created_at || '—'}</td>
                            <td>{row.type_name || row.donation_type_name || '—'}</td>
                            <td>{formatAmount(row.payment_amount)}</td>
                            <td>{row.order_id || row.payment_id || '—'}</td>
                            <td>
                              <span className="donation-status-pending">
                                {row.payment_status || 'Pending'}
                              </span>
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-sm donation-pay-btn"
                                disabled={busy}
                                onClick={() => payPendingDonation(row)}
                              >
                                {busy ? 'Redirecting…' : 'Make payment'}
                              </button>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              )}

              <p className="donation-history-link">
                <Link to="/DonationHistory">View full donation history</Link>
              </p>
            </div>
          ) : null}
        </div>
      </section>
      <Footer />
    </>
  )
}

export default Donation
